import {
  MotifModal,
  MotifModalBody,
  MotifModalFooter,
} from "@ey-xd/motif-react";
import "./DeleteProductModal.scss";
import Button from "../../../../components/Button/Button";
import { AppDispatch } from "../../../../store";
import { useDispatch } from "react-redux";
import {
  deleteOrderBundle,
  deleteProductInOrderBundleList,
} from "../../../../store/slices/CheckoutSlice";
import { removeOrderIdFromLocal } from "../../../../utils/common";
import { CANCEL_BUTTON_TEXT } from "../../../../Constant";
import { useEffect } from "react";

type Props = {
  isVisible: boolean;
  name: string;
  popupCloseHandler: () => void;
  setReloadPage: React.Dispatch<React.SetStateAction<boolean>>;
  productId: string;
  orderId: string;
  productsCount: number;
};

export default function DeleteProductModal({
  isVisible,
  name,
  popupCloseHandler,
  setReloadPage,
  productId,
  orderId,
  productsCount,
}: Props) {
  const dispatch = useDispatch<AppDispatch>();
  const handleClose = () => {
    popupCloseHandler();
  };

  useEffect(() => {
    if (isVisible) {
      document.body.style.overflow = "hidden";
    }
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isVisible]);

  const deleteBtnHandler = async () => {
    try {
      let OrderUpdateobj;
      let response;
      if (productsCount === 1) {
        OrderUpdateobj = {
          Action: "deleteOrder",
          OrderId: Number(orderId),
        };
        response = await dispatch(deleteOrderBundle(OrderUpdateobj));
      } else {
        OrderUpdateobj = {
          Action: "deleteProduct",
          OrderId: Number(orderId),
          ProductId: productId,
        };
        response = await dispatch(
          deleteProductInOrderBundleList(OrderUpdateobj)
        );
      }
      if (response.meta.requestStatus === "fulfilled") {
        if (productsCount === 1) {
          removeOrderIdFromLocal();
        }
        setReloadPage(true);
        popupCloseHandler();
      } else {
        console.error("Failed to update order:", response.payload.message);
      }
    } catch (error) {
      console.error("Error deleting product:", error);
    }
  };

  return (
    <>
      <MotifModal
        className={`DeleteProductModal ${name} `}
        onClose={handleClose}
        show={isVisible}
        focusTrapOptions={{
          tabbableOptions: {
            displayCheck: "none",
          },
        }}
      >
        <div className="DeleteProductModalModelWrapper">
          <MotifModalBody>
            <div className="discard_message">
              <p>{`Are you Sure you want to Delete this Product in Order Bundle ?`}</p>
              <p className="suggestion-text">
                This Product in order bundle will be permanently removed.
              </p>
            </div>
          </MotifModalBody>
          <MotifModalFooter>
            <Button
              label={CANCEL_BUTTON_TEXT}
              variant={"primary"}
              className="cancelBtnModal"
              onClickHandler={handleClose}
            />
            <Button
              label={"Delete"}
              variant={"secondary"}
              className="deleteBtnModal"
              onClickHandler={deleteBtnHandler}
            />
          </MotifModalFooter>
        </div>
      </MotifModal>
    </>
  );
}
